var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 419.71 476.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0 65.42 10.01 65.42 10.01 9.59 72.74 9.59 72.74 0 0 0 0 65.42",
    fill: "#0084dd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.01 410.67 0 410.67 0 476.03 72.74 476.03 72.74 466.45 10.01 466.45 10.01 410.67",
    fill: "#0084dd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.7 466.45 346.97 466.45 346.97 476.03 419.71 476.03 419.71 410.67 409.7 410.67 409.7 466.45",
    fill: "#0084dd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.97 0 346.97 9.59 409.7 9.59 409.7 65.42 419.71 65.42 419.71 0 346.97 0",
    fill: "#0084dd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.86,
    cy: 182.62,
    rx: 74.65,
    ry: 96.5,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.86,286.3c-62.45,0-117.41,19.08-149.51,48.01,35.18,43.68,89.06,71.65,149.51,71.65s114.34-27.97,149.51-71.65c-32.1-28.93-87.07-48.01-149.51-48.01Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 214.06,
    width: 73.71,
    height: 121.87,
    rx: 6.98,
    ry: 6.98,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.51,187.1c4.35,12.52,2.62,24.48-3.85,26.73s-15.24-6.08-19.59-18.59c-4.35-12.52-2.62-24.48,3.85-26.73,6.47-2.25,15.24,6.08,19.59,18.59Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.2,187.1c-4.35,12.52-2.62,24.48,3.85,26.73,6.47,2.25,15.24-6.08,19.59-18.59,4.35-12.52,2.62-24.48-3.85-26.73-6.47-2.25-15.24,6.08-19.59,18.59Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.52,186.7c-9.7-17.64-19.68-36.37-19.18-56.5,.5-20.13,15.82-41.38,35.95-40.65,3.51,.13,7.03,.9,10.51,.4,6.96-.99,12.12-6.68,17.76-10.87,12.73-9.45,30.46-11.69,45.14-5.71,9.07,3.7,16.75,10.16,25.6,14.37,16.49,7.84,36.81,7.01,52.61-2.13-3.3,6.2-8.87,11.15-15.42,13.69,6.04,1.93,12.72,1.74,18.65-.52-3.57,6.46-9.47,11.61-16.36,14.26,5.11,.35,10.22,.7,15.33,1.06-4.36,6.17-10.59,11.01-17.65,13.7,4,.13,8.01,.26,12.01,.39-2.98,8.83-10.71,15.9-19.78,18.08,2.58,.03,5.16,.07,7.75,.11-8.46,12.21-16.92,24.41-25.38,36.62-2.42,3.49-4.93,7.07-8.5,9.36-2.97,1.9-6.46,2.78-9.9,3.55-25.06,5.62-50.99,7.31-76.56,4.98-8.75-.79-17.9-2.23-24.85-7.6-6.95-5.37-10.68-15.87-5.89-23.24",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.73,304.53c.55-10.13,1.81-20.22,3.77-30.17,5.01,5.73,13.5,6.44,21.1,6.75,11.5,.47,23.01,.94,34.51,1.4,1.34,7.85,2.27,17.07-3.4,22.66-2.63,2.59-6.26,3.88-9.81,4.87-7.75,2.16-15.79,3.28-23.84,3.33-9.55,.06-20.92-2.8-23.98-11.85,1.04-.85,2.07-1.7,3.11-2.55",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.98,304.53c-.55-10.13-1.81-20.22-3.77-30.17-5.01,5.73-13.5,6.44-21.1,6.75-11.5,.47-23.01,.94-34.51,1.4-1.34,7.85-2.27,17.07,3.4,22.66,2.63,2.59,6.26,3.88,9.81,4.87,7.75,2.16,15.79,3.28,23.84,3.33,9.55,.06,20.92-2.8,23.98-11.85-1.04-.85-2.07-1.7-3.11-2.55",
    fill: "#4d4d4d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.01a2a437a26534530ddb9b3c69f7f2a8.svg";
export { ForwardRef as ReactComponent };